import React, { PureComponent, Fragment } from 'react'
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from '@material-ui/core'
import { MoreVert, Refresh, HistoryRounded, DeleteRounded } from '@material-ui/icons'

export class UserOptions extends PureComponent {
  state = {
    anchorEl: null
  }

  handleOpen = e => {
    this.setState({ anchorEl: e.currentTarget })
  }

  handleClose = () => this.setState({ anchorEl: null })

  onClick = type => () => {
    const { onOptionClick, email, uid } = this.props

    onOptionClick({ type, data: { email, uid } })
    this.handleClose()
  }

  render() {
    const { anchorEl } = this.state
    

    return (
      <Fragment>
        <IconButton onClick={this.handleOpen}>
          <MoreVert />
        </IconButton>

        <Menu
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
          anchorEl={anchorEl}
        >
          <MenuItem onClick={this.onClick('reset')}>
            <ListItemIcon>
              <Refresh />
            </ListItemIcon>

            <ListItemText inset primary='Скинути пароль' />
          </MenuItem>

          <MenuItem onClick={this.onClick('history')}>
            <ListItemIcon>
              <HistoryRounded />
            </ListItemIcon>

            <ListItemText inset primary='Історія' />
          </MenuItem>

          <MenuItem onClick={this.onClick('delete')}>
            <ListItemIcon>
              <DeleteRounded />
            </ListItemIcon>

            <ListItemText inset primary='Видалити користувача' />
          </MenuItem>
        </Menu>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Users/components/UserOptions/UserOptions.js